import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { http } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export const AuthCallback = () => {
  const { setUser } = useAuth();
  const navigate = useNavigate();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const sessionId = new URLSearchParams(hash.replace(/^#/, "")).get("session_id");

    (async () => {
      if (!sessionId) {
        navigate("/", { replace: true });
        return;
      }
      try {
        const res = await http.post("/auth/session", {}, { headers: { "X-Session-ID": sessionId } });
        setUser(res.data);
        window.history.replaceState(null, "", window.location.pathname);
        navigate(res.data.is_owner ? "/inquiries" : "/", { replace: true, state: { user: res.data } });
      } catch (e) {
        window.history.replaceState(null, "", "/");
        navigate("/", { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-[#EFEBDE]">
      <Loader2 size={32} className="animate-spin text-[#2C5F3A]" />
      <p className="mt-4 font-mono text-[11px] tracking-[0.2em] uppercase text-[#66766A]">Signing you in…</p>
    </div>
  );
};
